
import { Vue, Component, Prop } from "vue-property-decorator";
import { ImagePath } from "../views/ImagePath";

@Component({ components: {} })
export default class SmallGarally extends Vue {
  private inputMessage = "";
  public filterKeyword = "";
  public filterKeyword2 = "";
  public password = "public";
  public password2 = "";

  // created() {
  //   //   console.log(this.inputPassword);
  //   // this.inputPassword = "abc";
  // }

  public _inputPassword = "";
  public pass = this.inputPassword;
  private get inputPassword() {
    return this._inputPassword;
  }

  private set inputPassword(value: string) {
    console.log("inputPassword", value);
    /* this._inputPassword = value; */
    this._inputPassword = value;
    console.log(this._inputPassword);
  }
  @Prop({ default: [] })
  images!: ImagePath[];

  get imagesModel() {
    console.log(this.pass);

    return this.images.filter(
      (item) =>
        (item.publishing === this.password2 && this.filterKeyword == "") ||
        (item.publishing === this.password && this.filterKeyword == "") ||
        (item.publishing === this.password &&
          item.class !== this.filterKeyword &&
          item.class !== this.filterKeyword2) ||
        (item.publishing === this.password &&
          item.class !== this.filterKeyword &&
          item.class !== this.filterKeyword2)
    );
  }
  public onClick() {
    if (this._inputPassword == "levelenter") {
      this.password2 = "private";
    } else if (this._inputPassword == "") {
      alert("パスワードを入力してください");
    } else {
      alert("パスワードが違います");
      this.password2 = "";
    }
  }

  /* get imagesModel() {
    return this.images.filter(
      (item) =>
        this.$filterKeyword.filter1 == "" ||
        (item.class !== this.$filterKeyword.filter1 &&
          item.class !== this.$filterKeyword.filter2)
    );
  } */
  private filterB() {
    this.filterKeyword = "vrprogram";
    this.filterKeyword2 = "arprogram";
  }
  private filterA() {
    console.log("filter-A");
    console.log(this.images);
    this.filterKeyword = "3dmodel";
    console.log(this.images);
    this.filterKeyword2 = "arprogram";
  }
  private filterC() {
    this.filterKeyword = "3dmodel";
    this.filterKeyword2 = "vrprogram";
  }
  private clearFilter() {
    this.filterKeyword = "";
    this.filterKeyword2 = "";
  }

  private itemdelete(item: ImagePath) {
    this.$emit("deleteItem", item.name);
  }
  private linkpage(dest_url: string) {
    // const url = this.images[number].url;
    console.log(dest_url);
    window.location.href = dest_url;
  }
  /* mounted() {
    const targetElement = this.$refs.vrprogram;
    console.log("対象のDOM：", targetElement);
  } */
  /* private image_src(number: number) {
    console.log(this.images[number].path);
    const path = this.images[number].path;
    console.log(path);
    const img = path;
    return {
      img,
    };
  } */
  /* data(number:number){
      return {
        image_src: require(this.images[number].path)
      }
    }
  } */
}
